import React from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import { IDropdownOption } from 'components/forms'
import { EllipsisIcon } from 'transfix-icons'
import { OverflowMenu, useOverflowToggle } from 'transfix-ui'

interface IActionsMenuProps {
  options: IDropdownOption[]
  id: string
}

/** Wrapper around OverflowMenu component with internal display state and Ellipsis icon */
const ActionsMenu = ({ id, options }: IActionsMenuProps) => {
  const { clickOverflowTrigger, expanded, setExpanded } = useOverflowToggle()

  return (
    <OverflowMenu
      onExpanded={setExpanded}
      expanded={expanded}
      dropdownId={id}
      trigger={
        <IconButton
          Icon={EllipsisIcon}
          label='edit'
          data-test='edit-row'
          onClick={clickOverflowTrigger}
          size='large'
        />
      }
      options={options}
    />
  )
}

export default ActionsMenu
